import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Practitioner } from 'src/app/shared/models/practitioner.model';

@Component({
  selector: 'app-practitioner-edit-bio',
  templateUrl: './practitioner-edit-bio.component.html',
  styleUrls: ['./practitioner-edit-bio.component.scss']
})
export class PractitionerEditBioComponent implements OnInit {
  formGroup: FormGroup;

  @Input() isLoading: boolean;
  @Input() practitioner: Practitioner;
  @Output() dismissed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<FormGroup>();

  constructor() { }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      'bio': new FormControl(this.practitioner?.bio, [Validators.required, Validators.maxLength(700)]),
      'approach': new FormControl(this.practitioner?.approach, [Validators.required, Validators.maxLength(700)])
    });
  }

  onSubmit(): void {
    if (!this.formGroup.valid) { return; }
    this.submitted.emit(this.formGroup);
  }

  onDismiss(): void {
    this.dismissed.emit();
  }
}
